const upgradeUiCatalog = {
    "analytics.dashboard": {
        requiredPlan: "pro",
        featureName: "Analytics",
        title: "Unlock Analytics",
        description:
            "Analytics is available on Pro. See views, clicks, countries, and trends.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "content-overlay",
    },
    "shop.add-product": {
        requiredPlan: "pro",
        featureName: "Products",
        title: "Unlock Products",
        description:
            "Products are available on Pro. Showcase and sell products on your page.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-action",
    },
    "shop.manage-products": {
        requiredPlan: "pro",
        featureName: "Products",
        title: "Unlock Products",
        description:
            "Products are available on Pro. Showcase and manage products on your page.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-action",
    },
    "icons.visibility-limit": {
        requiredPlan: "pro",
        featureName: "More Social Icons",
        title: "Unlock More Social Icons",
        description:
            "Showing more than 2 icons is available on Pro. Upgrade to show all your social profiles.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "limit-notice",
    },
    "links.code-lock": {
        requiredPlan: "pro",
        featureName: "Code Lock",
        title: "Unlock Code Lock",
        description:
            "Code Lock is available on Pro. Protect links with a 4-digit code.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-setting",
    },
    "appearance.buttons.outline": {
        requiredPlan: "pro",
        featureName: "Outline Buttons",
        title: "Unlock Outline Buttons",
        description:
            "Outline button styles are available on Pro. Upgrade to customize your button style.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-setting",
    },
    "appearance.buttons.soft-shadow": {
        requiredPlan: "pro",
        featureName: "Soft Shadow Buttons",
        title: "Unlock Soft Shadow Buttons",
        description:
            "Soft shadow button styles are available on Pro. Upgrade to customize your button style.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-setting",
    },
    "appearance.buttons.hard-shadow": {
        requiredPlan: "pro",
        featureName: "Hard Shadow Buttons",
        title: "Unlock Hard Shadow Buttons",
        description:
            "Hard shadow button styles are available on Pro. Upgrade to customize your button style.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-setting",
    },
    "appearance.fonts.pro": {
        requiredPlan: "pro",
        featureName: "More Fonts",
        title: "Unlock More Fonts",
        description:
            "Additional fonts are available on Pro. Upgrade to apply more font styles to your profile.",
        descriptionTemplate:
            "{{featureName}} is available on {{planLabel}}. Upgrade to apply more font styles to your profile.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-setting",
    },
    "appearance.fonts.premium": {
        requiredPlan: "premium",
        featureName: "Premium Fonts",
        title: "Unlock Premium Fonts",
        description:
            "Premium fonts are available on Premium. Upgrade to apply exclusive font styles.",
        descriptionTemplate:
            "{{featureName}} is available on {{planLabel}}. Upgrade to apply exclusive font styles.",
        primaryCtaLabel: "Upgrade to Premium",
        pattern: "locked-setting",
    },
    "appearance.themes.pro": {
        requiredPlan: "pro",
        featureName: "Themes",
        title: "Unlock More Themes",
        description:
            "Additional themes are available on Pro. Upgrade to apply more theme styles to your page.",
        descriptionTemplate:
            "{{featureName}} is available on {{planLabel}}. Upgrade to apply more theme styles to your page.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-setting",
    },
    "appearance.themes.premium": {
        requiredPlan: "premium",
        featureName: "Premium Themes",
        title: "Unlock Premium Themes",
        description:
            "Premium themes are available on Premium. Upgrade to apply exclusive themes to your page.",
        descriptionTemplate:
            "{{featureName}} is available on {{planLabel}}. Upgrade to apply exclusive themes to your page.",
        primaryCtaLabel: "Upgrade to Premium",
        pattern: "locked-setting",
    },
    "links.platforms.pro": {
        requiredPlan: "pro",
        featureName: "App Integrations",
        title: "Unlock Pro Apps",
        description:
            "Some apps and modes are available on Pro. Upgrade to add advanced app integrations.",
        primaryCtaLabel: "Upgrade to Pro",
        pattern: "locked-setting",
    },
    "links.platforms.premium": {
        requiredPlan: "premium",
        featureName: "Premium App Integrations",
        title: "Unlock Premium Apps",
        description:
            "Some apps and modes are available on Premium. Upgrade to add premium app integrations.",
        primaryCtaLabel: "Upgrade to Premium",
        pattern: "locked-setting",
    },
    "digital-cards.create": {
        requiredPlan: "premium",
        featureName: "Digital Cards",
        title: "Unlock Digital Cards",
        description:
            "Digital Cards are available on Premium. Create a shareable digital card for your profile.",
        primaryCtaLabel: "Upgrade to Premium",
        pattern: "locked-action",
    },
};

export default upgradeUiCatalog;
